import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../constants/constants';

export const componentKey = "AUTHENTICATION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setIsUserAuthenticated: (state, action) => {
            state.isUserAuthenticated = action.payload;
        },

        setAuthenticationLoader: (state, action) => {
            state.authenticationLoader = action.payload;
        },
        setSignedInUser: (state, action) => {
            state.signedInUser = action.payload;
        },
        setTwoFA: (state, action) => {
            state.twoFAEnabled = action.payload;
        },
        setShowSessionError: (state, action) => {
            state.showSessionError = action.payload;
        },
    },
    initialReducerState: {
        isUserAuthenticated: false,
        authenticationLoader: { state: PAGE_STATE.PRE_LOADING },
        signedInUser: {},
        twoFAEnabled: false,
        showSessionError: false,
    }
});
export const { setIsUserAuthenticated, setAuthenticationLoader, setSignedInUser, setTwoFA, setShowSessionError } = actions;